import { Component, OnInit } from '@angular/core';
import { UserProfileService } from '../../services/user-profile.service';
import { AuthService } from '../../services/auth.service';
import { TenantRouterService } from '../../services/tenant-router.service';
import { Role } from '../../models/role';

@Component({
  selector: 'app-user-profile',
  standalone: false,
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent implements OnInit {

  userId!: number;
  userProfile: any = null;
  loading = true;

  constructor(
    private userProfileService: UserProfileService,
    private authService: AuthService,
    private tenantRouter: TenantRouterService
  ) { }

  ngOnInit(): void {
    const userid = sessionStorage.getItem('user_id');
    if (userid) {
      this.userId = parseInt(userid, 10);
    }
    this.loadProfile();
  }

  loadAspirationTypes(roleId: number) {
    return this.userProfileService.getRoleById(roleId);
  }

  loadProfile() {
    this.userProfileService.getProfile(this.userId).subscribe({
      next: (res) => {
        this.userProfile = res;
        if (res.hasAspiration && res.aspirationType !== null) {
          const typeVal = Number(res.aspirationType);
          if (typeVal === 0) {
            this.userProfile.aspirationType = 'Other';
          } else {
            this.loadAspirationTypes(typeVal).subscribe({
              next: (role: Role) => {
                this.userProfile.aspirationType = role.name;
              }
            });
          }
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  goToLinkRoute(route: string): void {
    this.tenantRouter.navigate(route);
  }
}
